import axiosClient from ".";
class ReferalAPI {
  static referal_stats(data) {
    return axiosClient.get(
      `/super_admin/api/user_referal_logs/${data.id}.json`
    );
  }
}
export default ReferalAPI;
